__webpack_require__.p = "/shop/front-webapp/";